export default "__VITE_ASSET__f4e38a92__"